import React, { Component } from 'react'
import { connect } from 'react-redux'

import Overlay from '../Atoms/Overlay'
import Settings from '../Organisms/Settings'
import TeamRegister from '../Organisms/TeamRegister'

import { reRegisterDevice } from '../../redux/device'

export default (ComponentToRender) => {
  class Splash extends Component {
    state = {
      showSplash: true,
      showSettings: false
    }

    componentDidUpdate (prevProps, prevState) {
      if (!prevProps.registered && this.props.registered) {
        this.closeSettings()
      }

      if (prevProps.registered && !this.props.registered) {
        this.setState({ showSplash: true })
      }

      if (prevProps.finishTime !== null && this.props.finishTime === null) {
        return this.setState({ showSplash: true })
      }

      if (prevProps.gameState !== 'locked' && !prevState.showSplash && this.props.gameState === 'locked') {
        this.setState({ showSplash: true })
      }

      if (prevProps.gameState !== 'submitted' && !prevState.showSplash && this.props.gameState === 'submitted') {
        this.setState({ showSplash: true })
      }

      if (prevState.showSplash && this.props.testMode && this.props.registered && this.props.teamRegistered) {
        this.setState({ showSplash: false })
      }
    }

    handleButtonPress = () => {
      this.setState({
        showSplash: !this.state.showSplash
      })
    }

    closeSettings = () => {
      this.setState({
        showSettings: false
      })
    }

    handleSettings = () => {
      this.setState({
        showSettings: true
      })
    }

    attemptReconnect = async () => {
      await this.props.reRegisterDevice()
    }

    render () {
      if (!this.state.showSplash) {
        if (!this.props.teamRegistered) {
          return (
            <Overlay>
              <TeamRegister />
            </Overlay>
          )
        }
        return null
      }
      if (this.state.showSettings) {
        return (
          <Overlay>
            <Settings
              closeSettings={this.closeSettings}
            />
          </Overlay>
        )
      }
      return (
        <ComponentToRender
          {...this.props}
          onSettingsPress={this.handleSettings}
          onButtonPress={this.handleButtonPress}
          buttonEnabled={this.props.buttonEnabled}
        />
      )
    }
  }

  return connect(mapStateToProps, {
    reRegisterDevice
  })(Splash)
}

const mapStateToProps = (state) => {
  const gameEnabled = state.game.state !== 'locked' && (state.game.finishTime !== null || state.game.state === 'wrapup')
  return {
    teamName: state.team.name,
    teamId: state.team.id,
    downloading: state.files.downloading && !state.files.downloaded,
    registered: state.device.registered,
    teamRegistered: state.team.registered,
    gameState: state.game.state,
    gameName: state.game.gameName,
    splashScreenTitle: state.game.splashScreenTitle,
    hasCustomLogo: state.game.hasCustomLogo,
    hasDownloadedCustomLogo: state.game.hasDownloadedCustomLogo,
    filesToDownload: state.files.filesToDownload,
    finishTime: state.game.finishTime,
    buttonEnabled: state.files.downloaded && state.device.registered && state.device.connected && gameEnabled,
    allowReconnect: state.device.hasSetupInfo && !state.device.registered,
    registerError: state.device.error,
    testMode: state.game.automate.testModeScreen || state.game.automate.testModeWidgets,
    participantDetails: state.device.participantDetails,
    gameStarted: state.game.currentRound > 0
  }
}
